class StoreLocatorMap extends HTMLElement {
  VB_LOGO_DATA_URL = 'data:image/webp;base64,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'

  constructor () {
    super()

    this.apiKey = this.dataset.apiKey || ''
    this.markerIconUrl = this.dataset.markerIcon || ''
    this.markerIconStoreUrl = this.dataset.markerIconStore || ''
    this.shopDomain = this.dataset.shopDomain || ''
    this.storefrontToken = this.dataset.storefrontToken || ''
    this.storefrontApiVersion = this.dataset.storefrontApiVersion || '2026-07'
    this.cartAddUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add'
    this.stockists = []
    this.embeddedStockists = []

    try {
      this.embeddedStockists = JSON.parse(this.dataset.stockists || '[]')
    } catch (e) {
      console.error('StoreLocatorMap: Failed to parse stockists JSON', e)
    }

    this.stockists = [...this.embeddedStockists]
    this.filteredStockists = [...this.stockists]
    this.searchQuery = ''
    this.storeFilter = 'vb'
    this.map = null
    this.markers = []
    this.infoWindow = null
    this.placeCache = {}
    this.placeRequestCount = 0
    this.maxPlaceRequests = 100

    this.els = {
      searchInput: this.querySelector('[data-store-locator-el="searchInput"]'),
      mapCanvas: this.querySelector('[data-store-locator-el="mapCanvas"]'),
      countText: this.querySelector('[data-store-locator-el="countText"]'),
      storeList: this.querySelector('[data-store-locator-el="storeList"]'),
      introContent: this.querySelector('[data-store-locator-el="introContent"]'),
      zoomIn: this.querySelector('[data-store-locator-el="zoomIn"]'),
      zoomOut: this.querySelector('[data-store-locator-el="zoomOut"]'),
      filterToggle: this.querySelector('[data-store-locator-el="filterToggle"]'),
      filterMenu: this.querySelector('[data-store-locator-el="filterMenu"]'),
      vbStoreFilter: this.querySelector('[data-store-locator-el="vbStoreFilter"]'),
      allStockistsFilter: this.querySelector('[data-store-locator-el="allStockistsFilter"]'),
      vbStoreFilterLabel: this.querySelector('[data-store-locator-el="vbStoreFilterLabel"]'),
      allStockistsFilterLabel: this.querySelector('[data-store-locator-el="allStockistsFilterLabel"]'),
      vbStoreFilterBottom: this.querySelector('[data-store-locator-el="vbStoreFilterBottom"]'),
      allStockistsFilterBottom: this.querySelector('[data-store-locator-el="allStockistsFilterBottom"]'),
      vbStoreFilterBottomLabel: this.querySelector('[data-store-locator-el="vbStoreFilterBottomLabel"]'),
      allStockistsFilterBottomLabel: this.querySelector('[data-store-locator-el="allStockistsFilterBottomLabel"]'),
    }

    this.hasInteracted = false
  }

  connectedCallback () {
    this.setupEventListeners()
    this.setInitialFilterState()

    if (this.storefrontToken && this.shopDomain) {
      this.fetchStockistsFromStorefront()
        .then((stockists) => {
          this.stockists = this.normalizeStockists(stockists.length > 0 ? stockists : [...this.embeddedStockists])
          console.log(`StoreLocatorMap: loaded ${this.stockists.length} stockists via Storefront API`, this.stockists)
          this.applyFilters()
          this.loadMap()
        })
        .catch((err) => {
          console.error('StoreLocatorMap: Storefront API fetch failed, falling back to embedded JSON', err)
          this.useEmbeddedStockists()
        })
    } else {
      this.useEmbeddedStockists()
    }
  }

  useEmbeddedStockists () {
    this.stockists = this.normalizeStockists([...this.embeddedStockists])

    if (this.stockists.length > 0) {
      console.log('StoreLocatorMap: stockists loaded from embedded JSON', this.stockists)
    } else {
      console.warn('StoreLocatorMap: no stockists loaded')
    }

    this.applyFilters()
    this.loadMap()
  }

  loadMap () {
    if (this.apiKey) {
      this.loadGoogleMapsScript()
        .then(() => this.loadMarkerClustererScript())
        .then(() => {
          this.initMap()
        })
        .catch(err => {
          console.error('StoreLocatorMap: Error loading map libraries', err)
          if (this.els.countText) {
            this.els.countText.textContent = `${this.filteredStockists.length} stores in this area`
          }
        })
    } else {
      if (this.els.countText) {
        this.els.countText.textContent = `${this.filteredStockists.length} stores in this area`
      }
    }
  }

  setupEventListeners () {
    if (this.els.searchInput) {
      this.els.searchInput.addEventListener('input', this.debounce((e) => {
        this.markInteraction()
        this.handleSearchInput(e)
      }, 250))
    }

    if (this.els.mapCanvas) {
      this.els.mapCanvas.addEventListener('click', () => {
        this.markInteraction()
      })
    }

    if (this.els.vbStoreFilter) {
      this.els.vbStoreFilter.addEventListener('change', this.handleStoreFilterChange.bind(this))
    }

    if (this.els.allStockistsFilter) {
      this.els.allStockistsFilter.addEventListener('change', this.handleStoreFilterChange.bind(this))
    }

    if (this.els.vbStoreFilterBottom) {
      this.els.vbStoreFilterBottom.addEventListener('change', this.handleStoreFilterChange.bind(this))
    }

    if (this.els.allStockistsFilterBottom) {
      this.els.allStockistsFilterBottom.addEventListener('change', this.handleStoreFilterChange.bind(this))
    }

    if (this.els.filterToggle && this.els.filterMenu) {
      this.els.filterToggle.addEventListener('click', (event) => {
        event.stopPropagation()
        this.toggleFilterMenu()
      })

      this.els.filterMenu.addEventListener('click', (event) => {
        event.stopPropagation()
      })

      document.addEventListener('click', () => {
        this.closeFilterMenu()
      })
    }

    if (this.els.zoomIn) {
      this.els.zoomIn.addEventListener('click', () => {
        if (this.map) {
          this.map.setZoom((this.map.getZoom() || 10) + 1)
        }
      })
    }

    if (this.els.zoomOut) {
      this.els.zoomOut.addEventListener('click', () => {
        if (this.map) {
          this.map.setZoom((this.map.getZoom() || 10) - 1)
        }
      })
    }
  }

  setInitialFilterState () {
    this.storeFilter = 'vb'
    this.syncFilterCheckboxes()
  }

  toggleFilterMenu () {
    if (!this.els.filterMenu || !this.els.filterToggle) return
    const isOpen = !this.els.filterMenu.hidden
    if (isOpen) {
      this.closeFilterMenu()
    } else {
      this.openFilterMenu()
    }
  }

  openFilterMenu () {
    if (!this.els.filterMenu || !this.els.filterToggle) return
    this.els.filterMenu.hidden = false
    this.els.filterToggle.setAttribute('aria-expanded', 'true')
    this.els.filterToggle.parentElement.classList.add('is-open')
  }

  closeFilterMenu () {
    if (!this.els.filterMenu || !this.els.filterToggle) return
    this.els.filterMenu.hidden = true
    this.els.filterToggle.setAttribute('aria-expanded', 'false')
    this.els.filterToggle.parentElement.classList.remove('is-open')
  }

  debounce (func, wait) {
    let timeout
    return function executedFunction (...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }

  loadGoogleMapsScript () {
    if (window.google && window.google.maps) {
      return Promise.resolve()
    }

    if (window._googleMapsLoadingPromise) {
      return window._googleMapsLoadingPromise
    }

    window._googleMapsLoadingPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(this.apiKey)}&libraries=places`
      script.async = true
      script.defer = true

      script.onload = () => resolve()
      script.onerror = (err) => reject(err)

      document.head.appendChild(script)
    })

    return window._googleMapsLoadingPromise
  }

  loadMarkerClustererScript () {
    if (window.markerClusterer || window.MarkerClusterer) {
      return Promise.resolve()
    }

    if (window._markerClustererLoadingPromise) {
      return window._markerClustererLoadingPromise
    }

    window._markerClustererLoadingPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = 'https://unpkg.com/@googlemaps/markerclusterer/dist/index.umd.js'
      script.async = true
      script.defer = true

      script.onload = () => resolve()
      script.onerror = (err) => reject(err)

      document.head.appendChild(script)
    })

    return window._markerClustererLoadingPromise
  }

  async fetchStockistsFromStorefront () {
    const flatStockists = await this.fetchAllMetaobjects('stockists', [
      'name', 'address', 'city', 'postcode', 'latitude', 'longitude',
      'phone', 'hours', 'opening_times', 'about', 'stockist_info',
      'website', 'address_info', 'store', 'place_id', 'meety_service_product_id',
    ])

    const stockists = flatStockists.map((stockist) => {
      const lat = parseFloat(this.getMetaobjectFieldValue(stockist, 'latitude') || '')
      const lng = parseFloat(this.getMetaobjectFieldValue(stockist, 'longitude') || '')
      const productGid = this.parseGidValue(this.getMetaobjectFieldValue(stockist, 'meety_service_product_id'))

      return {
        id: stockist.handle || stockist.id,
        name: this.getMetaobjectFieldValue(stockist, 'name') || '',
        city: this.getMetaobjectFieldValue(stockist, 'city') || '',
        address: this.getMetaobjectFieldValue(stockist, 'address') || '',
        address_info: this.getMetaobjectFieldValue(stockist, 'address_info') || '',
        postcode: this.getMetaobjectFieldValue(stockist, 'postcode') || '',
        country: '',
        region: '',
        phone: this.getMetaobjectFieldValue(stockist, 'phone') || '',
        hours: this.getMetaobjectFieldValue(stockist, 'hours') || '',
        opening_times: this.getMetaobjectFieldValue(stockist, 'opening_times') || '',
        about: this.getMetaobjectFieldValue(stockist, 'about') || '',
        stockist_info: this.getMetaobjectFieldValue(stockist, 'stockist_info') || '',
        website: this.getMetaobjectFieldValue(stockist, 'website') || '',
        store: this.parseBoolean(this.getMetaobjectFieldValue(stockist, 'store')),
        place_id: this.parseGidValue(this.getMetaobjectFieldValue(stockist, 'place_id')) || '',
        product_gid: productGid,
        product_id: this.extractProductId(productGid),
        meety_product_id: '',
        lat: isNaN(lat) ? null : lat,
        lng: isNaN(lng) ? null : lng,
      }
    })

    const productGids = [...new Set(stockists.map(s => s.product_gid).filter(Boolean))]
    if (productGids.length > 0) {
      const variantMap = await this.fetchFirstVariantIds(productGids)
      stockists.forEach((stockist) => {
        stockist.meety_product_id = variantMap.get(stockist.product_gid) || ''
      })
    }

    return stockists
  }

  async fetchFirstVariantIds (productGids) {
    const query = `
      query ProductVariants($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on Product {
            id
            variants(first: 1) {
              edges {
                node {
                  id
                }
              }
            }
          }
        }
      }
    `

    const json = await this.storefrontFetch(query, { ids: productGids })
    const nodes = json.data && json.data.nodes
    const variantMap = new Map()

    if (!nodes) return variantMap

    nodes.forEach((product) => {
      if (!product || !product.variants || !product.variants.edges || !product.variants.edges[0]) return
      const variantId = this.extractProductId(product.variants.edges[0].node.id)
      variantMap.set(product.id, variantId)
    })

    return variantMap
  }

  async buildCountryRegionMap () {
    const regions = await this.fetchAllMetaobjects('stockist_region', ['name'])
    const regionNames = new Map()
    regions.forEach((region) => {
      regionNames.set(region.id, this.getMetaobjectFieldValue(region, 'name') || '')
    })

    const countries = await this.fetchAllMetaobjects('stockist_country', ['name'], ['region'])
    const stockistToCountry = new Map()

    for (const country of countries) {
      const countryName = this.getMetaobjectFieldValue(country, 'name') || ''
      const regionId = country.region && country.region.reference ? country.region.reference.id : null
      const regionName = regionNames.get(regionId) || ''

      const stockists = await this.fetchAllReferences(country.id, 'stockists')
      stockists.forEach((stockist) => {
        stockistToCountry.set(stockist.id, { country: countryName, region: regionName })
      })
    }

    return stockistToCountry
  }

  async fetchAllMetaobjects (type, fieldKeys, referenceKeys = []) {
    const fieldsFragment = fieldKeys.map(key => `${key}: field(key: "${key}") { value }`).join('\n')
    const referencesFragment = referenceKeys.map(key => `${key}: field(key: "${key}") { reference { ... on Product { id } ... on ProductVariant { id } ... on Metaobject { id } } }`).join('\n')
    const query = `
      query Metaobjects($type: String!, $first: Int!, $after: String) {
        metaobjects(type: $type, first: $first, after: $after) {
          edges {
            cursor
            node {
              id
              handle
              ${fieldsFragment}
              ${referencesFragment}
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    `

    const results = []
    let after = null
    const first = 250

    while (true) {
      const json = await this.storefrontFetch(query, { type, first, after })
      const connection = json.data && json.data.metaobjects

      if (!connection || !connection.edges) {
        throw new Error('StoreLocatorMap: invalid metaobjects response')
      }

      results.push(...connection.edges.map(edge => edge.node))

      if (!connection.pageInfo.hasNextPage) break
      after = connection.pageInfo.endCursor
    }

    return results
  }

  async fetchAllReferences (parentId, fieldKey, fieldKeys = []) {
    const fieldsFragment = fieldKeys.map(key => `${key}: field(key: "${key}") { value }`).join('\n')
    const query = `
      query References($parentId: ID!, $fieldKey: String!, $first: Int!, $after: String) {
        metaobject(id: $parentId) {
          field(key: $fieldKey) {
            references(first: $first, after: $after) {
              edges {
                cursor
                node {
                  ... on Metaobject {
                    id
                    handle
                    ${fieldsFragment}
                  }
                }
              }
              pageInfo {
                hasNextPage
                endCursor
              }
            }
          }
        }
      }
    `

    const results = []
    let after = null
    const first = 250

    while (true) {
      const json = await this.storefrontFetch(query, { parentId, fieldKey, first, after })
      const metaobject = json.data && json.data.metaobject
      const connection = metaobject && metaobject.field && metaobject.field.references

      if (!connection || !connection.edges) {
        throw new Error('StoreLocatorMap: invalid references response')
      }

      results.push(...connection.edges.map(edge => edge.node))

      if (!connection.pageInfo.hasNextPage) break
      after = connection.pageInfo.endCursor
    }

    return results
  }

  async storefrontFetch (query, variables = {}) {
    console.log('StoreLocatorMap Storefront API query:', { query, variables })
    const endpoint = `https://${this.shopDomain}/api/${this.storefrontApiVersion}/graphql.json`
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': this.storefrontToken,
      },
      body: JSON.stringify({ query, variables }),
    })

    if (!response.ok) {
      throw new Error(`Storefront API error: ${response.status} ${response.statusText}`)
    }

    const json = await response.json()

    if (json.errors) {
      throw new Error(json.errors.map(e => e.message).join(', '))
    }

    return json
  }

  getMetaobjectFieldValue (metaobject, key) {
    if (!metaobject || !metaobject[key]) return ''
    return metaobject[key].value || ''
  }

  getReferenceId (metaobject, key) {
    if (!metaobject || !metaobject[key]) return ''
    const reference = metaobject[key].reference
    return reference ? reference.id : ''
  }

  parseBoolean (value) {
    if (typeof value === 'boolean') return value
    return String(value).toLowerCase() === 'true'
  }

  extractProductId (value) {
    if (!value || typeof value !== 'string' || !value.trim()) {
      return ''
    }
    return value.split('/').pop() || ''
  }

  parseGidValue (value) {
    if (!value) return ''
    if (typeof value !== 'string') return String(value)
    if (value.startsWith('gid://')) return value

    try {
      const parsed = JSON.parse(value)
      if (Array.isArray(parsed)) return parsed[0] || ''
      if (typeof parsed === 'string') return parsed
      return String(parsed)
    } catch (e) {
      return value
    }
  }

  normalizeStockists (stockists) {
    return stockists.map((stockist) => {
      return {
        ...stockist,
        address_info: this.renderRichText(stockist.address_info),
        opening_times: this.renderRichText(stockist.opening_times),
        stockist_info: this.renderRichText(stockist.stockist_info),
        meety_product_id: this.extractProductId(stockist.meety_product_id),
      }
    })
  }

  renderRichText (value) {
    if (!value) return ''

    if (typeof value === 'string') {
      try {
        value = JSON.parse(value)
      } catch (e) {
        return this.escapeHtml(value).replace(/\n/g, '<br>')
      }
    }

    if (typeof value !== 'object' || !value.type) {
      return this.escapeHtml(String(value)).replace(/\n/g, '<br>')
    }

    return this.renderRichTextNode(value)
  }

  renderRichTextNode (node) {
    if (!node) return ''

    const children = node.children
      ? node.children.map(child => this.renderRichTextNode(child)).join('')
      : ''

    switch (node.type) {
      case 'root':
      case 'document':
        return children
      case 'paragraph':
        return `<p>${children}</p>`
      case 'text':
        return this.renderRichTextText(node)
      case 'link':
        return this.renderRichTextLink(node, children)
      case 'list':
        return node.listType === 'ordered' ? `<ol>${children}</ol>` : `<ul>${children}</ul>`
      case 'list-item':
        return `<li>${children}</li>`
      default:
        return children || this.escapeHtml(node.value || '')
    }
  }

  renderRichTextText (node) {
    let text = this.escapeHtml(node.value || '')
    if (node.bold) text = `<strong>${text}</strong>`
    if (node.italic) text = `<em>${text}</em>`
    return text
  }

  renderRichTextLink (node, children) {
    const url = this.escapeHtml(node.url || '#')
    const target = node.target ? ` target="${this.escapeHtml(node.target)}" rel="noopener noreferrer"` : ''
    return `<a href="${url}"${target}>${children}</a>`
  }

  escapeHtml (text) {
    if (text == null) return ''
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;')
  }

  initMap () {
    if (!this.els.mapCanvas || !window.google || !window.google.maps) return

    const defaultCenter = { lat: 51.5074, lng: -0.1278 } // Default London

    this.map = new window.google.maps.Map(this.els.mapCanvas, {
      zoom: 5,
      center: defaultCenter,
      disableDefaultUI: true, // Hide default controls, we use custom zoom box
      styles: [
        {
          elementType: 'geometry',
          stylers: [{ color: '#f5f5f5' }],
        },
        {
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off' }],
        },
        {
          elementType: 'labels.text.fill',
          stylers: [{ color: '#616161' }],
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [{ color: '#f5f5f5' }],
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#bdbdbd' }],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [{ color: '#eeeeee' }],
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#757575' }],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [{ color: '#e5e5e5' }],
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#9e9e9e' }],
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{ color: '#ffffff' }],
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#757575' }],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [{ color: '#dadada' }],
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#616161' }],
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#9e9e9e' }],
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [{ color: '#e5e5e5' }],
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [{ color: '#eeeeee' }],
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{ color: '#c9c9c9' }],
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#9e9e9e' }],
        },
      ],
    })

    this.infoWindow = new window.google.maps.InfoWindow({ maxWidth: 380 })
    this.placesService = new window.google.maps.places.PlacesService(this.map)
    this.markerCluster = null

    this.updateMapMarkers()
  }

  handleSearchInput (e) {
    this.searchQuery = (e.target.value || '').trim().toLowerCase()
    this.applyFilters()
  }

  handleStoreFilterChange (e) {
    const el = e.target
    const isVb = el === this.els.vbStoreFilter || el === this.els.vbStoreFilterBottom
    const isAll = el === this.els.allStockistsFilter || el === this.els.allStockistsFilterBottom

    if (isVb && el.checked) {
      this.storeFilter = 'vb'
    } else if (isAll && el.checked) {
      this.storeFilter = 'all'
    } else {
      const anyVbChecked = this.els.vbStoreFilter?.checked || this.els.vbStoreFilterBottom?.checked
      const anyAllChecked = this.els.allStockistsFilter?.checked || this.els.allStockistsFilterBottom?.checked
      if (!anyVbChecked && !anyAllChecked) {
        this.storeFilter = 'all'
      }
    }

    this.syncFilterCheckboxes()
    this.applyFilters()
  }

  syncFilterCheckboxes () {
    const vbChecked = this.storeFilter === 'vb'
    const allChecked = this.storeFilter === 'all'

    if (this.els.vbStoreFilter) this.els.vbStoreFilter.checked = vbChecked
    if (this.els.allStockistsFilter) this.els.allStockistsFilter.checked = allChecked
    if (this.els.vbStoreFilterBottom) this.els.vbStoreFilterBottom.checked = vbChecked
    if (this.els.allStockistsFilterBottom) this.els.allStockistsFilterBottom.checked = allChecked
  }

  applyFilters () {
    let result = [...this.stockists]

    if (this.storeFilter === 'vb') {
      result = result.filter(stockist => stockist.store)
    }

    this.updateFilterCounts()

    if (this.searchQuery) {
      const query = this.searchQuery
      const withName = []
      const withCity = []
      const withAddress = []
      const other = []

      result.forEach((stockist) => {
        const name = (stockist.name || '').toLowerCase()
        const city = (stockist.city || '').toLowerCase()
        const address = (stockist.address || '').toLowerCase()
        const postcode = (stockist.postcode || '').toLowerCase()
        const country = (stockist.country || '').toLowerCase()
        const region = (stockist.region || '').toLowerCase()

        if (name.includes(query)) {
          withName.push(stockist)
        } else if (city.includes(query)) {
          withCity.push(stockist)
        } else if (address.includes(query)) {
          withAddress.push(stockist)
        } else if (
          postcode.includes(query) ||
          country.includes(query) ||
          region.includes(query)
        ) {
          other.push(stockist)
        }
      })

      result = [...withName, ...withCity, ...withAddress, ...other]
    }

    this.filteredStockists = result
    this.renderStoreList()
    this.updateMapMarkers()
  }

  updateFilterCounts () {
    const vbCount = this.stockists.filter(stockist => stockist.store).length
    const allCount = this.stockists.length

    if (this.els.vbStoreFilterLabel) {
      this.els.vbStoreFilterLabel.textContent = `VB Stores (${vbCount})`
    }
    if (this.els.allStockistsFilterLabel) {
      this.els.allStockistsFilterLabel.textContent = `Stockists (${allCount})`
    }
    if (this.els.vbStoreFilterBottomLabel) {
      this.els.vbStoreFilterBottomLabel.textContent = `VB Stores (${vbCount})`
    }
    if (this.els.allStockistsFilterBottomLabel) {
      this.els.allStockistsFilterBottomLabel.textContent = `Stockists (${allCount})`
    }
  }

  buildMarkerIcon (isStore = false) {
    const size = 44
    const half = size / 2

    if (isStore && this.markerIconStoreUrl) {
      return {
        url: this.markerIconStoreUrl,
        scaledSize: new window.google.maps.Size(size, size),
        anchor: new window.google.maps.Point(half, half),
      }
    }

    if (this.markerIconUrl) {
      return {
        url: this.markerIconUrl,
        scaledSize: new window.google.maps.Size(size, size),
        anchor: new window.google.maps.Point(half, half),
      }
    }

    // Fallback bubble pin when no marker icon asset is configured
    const fill = isStore ? '#000000' : '#ffffff'
    const stroke = isStore ? '#ffffff' : '#000000'
    const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
        <circle cx="${half}" cy="${half}" r="${half - 1}" fill="${fill}" stroke="${stroke}" stroke-width="2"/>
      </svg>
    `
    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      scaledSize: new window.google.maps.Size(size, size),
      anchor: new window.google.maps.Point(half, half),
    }
  }

  updateMapMarkers () {
    if (!this.map || !window.google || !window.google.maps) return

    // Clear existing cluster and markers
    if (this.markerCluster) {
      this.markerCluster.clearMarkers()
      this.markerCluster = null
    }

    this.markers.forEach(marker => marker.setMap(null))
    this.markers = []

    if (this.filteredStockists.length === 0) return

    const bounds = new window.google.maps.LatLngBounds()

    this.filteredStockists.forEach((stockist, index) => {
      const lat = parseFloat(stockist.lat !== undefined ? stockist.lat : stockist.latitude)
      const lng = parseFloat(stockist.lng !== undefined ? stockist.lng : stockist.longitude)

      if (isNaN(lat) || isNaN(lng)) return

      const position = { lat, lng }
      bounds.extend(position)

      const marker = new window.google.maps.Marker({
        position,
        title: stockist.name || stockist.city || 'Store',
        icon: this.buildMarkerIcon(stockist.store),
      })

      marker.addListener('click', () => {
        this.selectStockist(stockist, marker)
      })

      this.markers.push(marker)
    })

    this.initMarkerCluster()

    if (this.markers.length > 0) {
      if (this.markers.length === 1) {
        this.map.setCenter(bounds.getCenter())
        this.map.setZoom(14)
      } else {
        this.map.fitBounds(bounds)
      }
    }
  }

  initMarkerCluster () {
    if (!this.markers.length) return

    if (window.markerClusterer && window.markerClusterer.MarkerClusterer) {
      this.markerCluster = new window.markerClusterer.MarkerClusterer({
        map: this.map,
        markers: this.markers,
        renderer: {
          render: ({ count, position }) => {
            return new window.google.maps.Marker({
              position,
              icon: this.buildClusterIcon(count),
              zIndex: Number(window.google.maps.Marker.MAX_ZINDEX) + count,
            })
          },
        },
      })
    } else if (window.MarkerClusterer) {
      this.markerCluster = new window.MarkerClusterer(this.map, this.markers, {
        imagePath: 'https://unpkg.com/@googlemaps/markerclustererplus/dist/images/m',
      })
    }
  }

  buildClusterIcon (count) {
    const size = 64
    const half = size / 2
    const logoSize = 26
    const logoY = 6
    const countY = logoY + logoSize + 8
    const labelY = countY + 11

    const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
        <circle cx="${half}" cy="${half}" r="${half - 1}" fill="#ffffff" stroke="#000000" stroke-width="2"/>
        <image href="${this.VB_LOGO_DATA_URL}" x="${(size - logoSize) / 2}" y="${logoY}" width="${logoSize}" height="${logoSize}" preserveAspectRatio="xMidYMid meet"/>
        <text x="${half}" y="${countY}" text-anchor="middle" font-family="canada-type-gibson, sans-serif" font-size="10" font-weight="400" fill="#000000">${count}</text>
        <text x="${half}" y="${labelY}" text-anchor="middle" font-family="canada-type-gibson, sans-serif" font-size="10" font-weight="400" fill="#000000">shops</text>
      </svg>
    `
    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      scaledSize: new window.google.maps.Size(size, size),
      anchor: new window.google.maps.Point(half, half),
    }
  }

  fetchPlaceDetails (stockist, callback) {
    if (!this.placesService) {
      callback(null)
      return
    }

    const query = [stockist.name, stockist.address, stockist.city, stockist.country]
      .filter(Boolean)
      .join(' ')

    const cacheKey = stockist.id || query
    if (!this.placeCache) this.placeCache = {}
    if (this.placeCache.hasOwnProperty(cacheKey)) {
      callback(this.placeCache[cacheKey])
      return
    }

    if (this.placeRequestCount >= this.maxPlaceRequests) {
      console.warn('StoreLocatorMap: Places API session limit reached')
      this.placeCache[cacheKey] = null
      callback(null)
      return
    }

    if (stockist.place_id) {
      this.placeRequestCount += 1
      this.fetchPlaceDetailsById(stockist.place_id, cacheKey, (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
          this.placeCache[cacheKey] = place
          callback(place)
          return
        }

        this.searchPlaceByQuery(stockist, query, cacheKey, callback)
      })
      return
    }

    this.searchPlaceByQuery(stockist, query, cacheKey, callback)
  }

  searchPlaceByQuery (stockist, query, cacheKey, callback) {
    this.placeRequestCount += 1
    this.placesService.findPlaceFromQuery(
      {
        query,
        fields: ['place_id', 'geometry'],
      },
      (results, status) => {
        if (status !== window.google.maps.places.PlacesServiceStatus.OK || !results || !results[0]) {
          this.placeCache[cacheKey] = null
          callback(null)
          return
        }

        this.fetchPlaceDetailsById(results[0].place_id, cacheKey, callback)
      }
    )
  }

  fetchPlaceDetailsById (placeId, cacheKey, callback) {
    this.placesService.getDetails(
      {
        placeId,
        fields: ['name', 'formatted_phone_number', 'opening_hours', 'photos', 'formatted_address'],
      },
      (place, detailStatus) => {
        if (detailStatus !== window.google.maps.places.PlacesServiceStatus.OK || !place) {
          this.placeCache[cacheKey] = null
          if (callback) callback(null, detailStatus)
          return
        }
        this.placeCache[cacheKey] = place
        if (callback) callback(place, detailStatus)
      }
    )
  }

  formatTime (time) {
    if (!time) return ''
    const raw = String(time)
    const hours = parseInt(raw.slice(0, 2), 10)
    const minutes = raw.slice(2, 4)
    const suffix = hours >= 12 ? 'pm' : 'am'
    const displayHours = hours % 12 === 0 ? 12 : hours % 12
    return minutes === '00' ? `${displayHours}${suffix}` : `${displayHours}:${minutes}${suffix}`
  }

  formatTodaysHours (openingHours) {
    if (!openingHours) return null

    const periods = openingHours.periods || []
    const today = new Date().getDay()
    const period = periods.find(p => p.open && p.open.day === today)

    if (!period || !period.open || !period.close) {
      return { text: 'Closed today', isOpen: false }
    }

    const now = new Date()
    const currentMinutes = now.getHours() * 60 + now.getMinutes()

    const openMinutes = parseInt(period.open.time.slice(0, 2), 10) * 60 + parseInt(period.open.time.slice(2, 4), 10)
    const closeMinutes = parseInt(period.close.time.slice(0, 2), 10) * 60 + parseInt(period.close.time.slice(2, 4), 10)

    const isOpen = currentMinutes >= openMinutes && currentMinutes < closeMinutes
    const text = `Open today from ${this.formatTime(period.open.time)} until ${this.formatTime(period.close.time)}`

    return { text, isOpen }
  }

  buildInfoWindowContent (stockist, place) {
    const title = stockist.city
      ? `${stockist.city}${stockist.country ? ', ' + stockist.country : ''}`
      : stockist.name || 'Store'

    const name = (place && place.name) || stockist.name || ''
    const address = (place && place.formatted_address) || stockist.address || ''
    const phone = (place && place.formatted_phone_number) || stockist.phone || ''
    const todaysHours = this.formatTodaysHours(place && place.opening_hours)

    let hoursHtml = ''
    if (todaysHours) {
      hoursHtml = `<p class="store-locator__info-hours">
        <span class="store-locator__info-status ${todaysHours.isOpen ? 'store-locator__info-status--open' : 'store-locator__info-status--closed'}"></span>
        ${this.escapeHtml(todaysHours.text)}
      </p>`
    } else if (stockist.opening_times) {
      hoursHtml = `<div class="store-locator__info-hours">
        <span class="store-locator__info-status store-locator__info-status--closed"></span>
        ${stockist.opening_times}
      </div>`
    } else if (stockist.hours) {
      hoursHtml = `<p class="store-locator__info-hours">
        <span class="store-locator__info-status store-locator__info-status--closed"></span>
        ${this.escapeHtml(stockist.hours)}
      </p>`
    } else {
      hoursHtml = `<p class="store-locator__info-hours">
        <span class="store-locator__info-status store-locator__info-status--closed"></span>
        Opening times not available
      </p>`
    }

    let photoUrl = ''
    if (place && place.photos && place.photos.length > 0) {
      photoUrl = place.photos[0].getUrl({ maxWidth: 420, maxHeight: 280 })
    }

    return `
      <div class="store-locator__info-window">
        ${photoUrl ? `
          <div class="store-locator__info-media">
            <img src="${photoUrl}" alt="${this.escapeHtml(title)}" loading="lazy">
          </div>
        ` : ''}
        <div class="store-locator__info-body">
          <h3 class="store-locator__info-title">${this.escapeHtml(title)}</h3>
          ${name ? `<p class="store-locator__info-name">${this.escapeHtml(name)}</p>` : ''}
          ${address ? `<p class="store-locator__info-address">${this.escapeHtml(address)}</p>` : ''}
          ${phone ? `<p class="store-locator__info-phone">Tel: ${this.escapeHtml(phone)}</p>` : `<p class="store-locator__info-phone">Tel: ${this.escapeHtml(stockist.phone || 'Contact store')}</p>`}
          ${hoursHtml}
        </div>
      </div>
    `
  }

  escapeHtml (text) {
    if (text == null) return ''
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;')
  }

  openInfoWindow (stockist, marker) {
    if (!this.infoWindow) return

    this.infoWindowMarker = marker

    const loadingContent = `
      <div class="store-locator__info-window">
        <p class="store-locator__info-loading">Loading store details…</p>
      </div>
    `

    this.infoWindow.setContent(loadingContent)
    this.infoWindow.open(this.map, marker)

    this.fetchPlaceDetails(stockist, (place) => {
      if (this.infoWindowMarker !== marker) return

      const content = this.buildInfoWindowContent(stockist, place)
      this.infoWindow.setContent(content)
    })
  }

  highlightStoreCard (storeId) {
    const cards = this.querySelectorAll('.store-locator__card')
    cards.forEach((card) => {
      if (card.dataset.storeId === String(storeId)) {
        card.classList.add('store-locator__card--active')
        card.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
      } else {
        card.classList.remove('store-locator__card--active')
      }
    })
  }

  selectStockist (stockist, marker = null) {
    this.markInteraction()

    const headingText = stockist.city
      ? `${stockist.city}${stockist.country ? ', ' + stockist.country : ''}`
      : stockist.name || 'Store'

    if (this.els.searchInput) {
      this.els.searchInput.value = headingText
    }

    this.filteredStockists = [stockist]
    this.renderStoreList()

    if (marker) {
      this.openInfoWindow(stockist, marker)
    }
  }

  markInteraction () {
    if (this.hasInteracted) return
    this.hasInteracted = true
    if (this.els.introContent) {
      this.els.introContent.remove()
      this.els.introContent = null
    }
  }

  renderStoreList () {
    if (this.els.countText) {
      this.els.countText.textContent = `${this.filteredStockists.length} stores in this area`
    }

    if (!this.els.storeList) return

    if (!this.hasInteracted && this.els.introContent) {
      return
    }

    if (this.filteredStockists.length === 0) {
      this.els.storeList.innerHTML = `
        <div class="store-locator__no-results">
          No stores found matching your search location.
        </div>
      `
      return
    }

    const isSingle = this.filteredStockists.length === 1

    const html = this.filteredStockists.map((stockist) => {
      const headingText = stockist.city
        ? `${stockist.city}${stockist.country ? ', ' + stockist.country : ''}`
        : stockist.name || 'Store'

      const storeValue = String(stockist.store).toLowerCase()
      const isStore = stockist.store === true || storeValue === 'true' || storeValue === '1'

      return `
        <div
          class="store-locator__card${isSingle ? ' store-locator__card--active' : ''}"
          data-store-id="${stockist.id}"
          tabindex="0"
          role="button"
          aria-label="View ${stockist.name || headingText} on map"
        >
          ${!isStore ? `<h3 class="store-locator__card-title">${headingText}</h3>` : ''}
          <div class="store-locator__card-details">
            ${stockist.name ? `<p class="store-locator__card-name">${stockist.name}</p>` : ''}
            ${stockist.stockist_info ? `<div class="store-locator__card-info">${stockist.stockist_info}</div>` : ''}
            ${isSingle && stockist.about ? `<p class="store-locator__card-about">${this.escapeHtml(stockist.about)}</p>` : ''}
            ${isSingle && stockist.website ? `<a class="store-locator__card-website" href="${this.escapeHtml(stockist.website)}" target="_blank" rel="noopener noreferrer">${this.escapeHtml(stockist.website)}</a>` : ''}
            ${(stockist.address_info || stockist.address) ? `<div class="store-locator__card-address">${stockist.address_info || stockist.address}</div>` : ''}
            ${stockist.phone ? `<p class="store-locator__card-phone">Tel: ${stockist.phone}</p>` : ''}
            ${stockist.opening_times ? `<div class="store-locator__card-hours">${stockist.opening_times}</div>` : ''}
            ${stockist.hours ? `<p class="store-locator__card-phone" style="margin-top: 6px;">${stockist.hours}</p>` : ''}
            ${this.buildScheduleButtonHtml(stockist)}
          </div>
        </div>
      `
    }).join('')

    this.els.storeList.innerHTML = html

    this.attachScheduleButtons()

    // Add click listeners to store cards
    const cards = this.els.storeList.querySelectorAll('.store-locator__card')
    cards.forEach((card) => {
      card.addEventListener('click', (event) => {
        if (event.target.closest('.store-locator__schedule-button')) {
          return
        }

        const storeId = card.dataset.storeId
        const stockist = this.filteredStockists.find(s => String(s.id) === String(storeId))
        if (!stockist) return

        const lat = parseFloat(stockist.lat !== undefined ? stockist.lat : stockist.latitude)
        const lng = parseFloat(stockist.lng !== undefined ? stockist.lng : stockist.longitude)

        let targetMarker = null
        if (this.map && !isNaN(lat) && !isNaN(lng)) {
          const position = { lat, lng }
          this.map.panTo(position)
          this.map.setZoom(14)

          targetMarker = this.markers.find((m) => {
            const pos = m.getPosition()
            return pos && Math.abs(pos.lat() - lat) < 0.0001 && Math.abs(pos.lng() - lng) < 0.0001
          })
        }

        this.selectStockist(stockist, targetMarker)
      })
    })
  }

  buildScheduleButtonHtml (stockist) {
    const storeValue = String(stockist.store).toLowerCase()
    const isStore = stockist.store === true || storeValue === 'true' || storeValue === '1'
    if (!isStore || !stockist.product_id) return ''

    return `
      <button
        type="button"
        class="product-form__submit button button--full-width button--secondary store-locator__schedule-button"
        data-appointment-button-product-id="${stockist.product_id}"
        data-store-locator-el="scheduleTrigger"
      >
        <span>SCHEDULE YOUR TIME</span>
      </button>
    `
  }

  attachScheduleButtons () {
    const buttons = this.querySelectorAll('[data-store-locator-el="scheduleTrigger"]')
    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.stopPropagation()
        const productId = button.dataset.appointmentButtonProductId
        if (!productId) return
        const target = document.querySelector(`[data-appointment-button-product-id="${productId}"] .product-form__buttons .meety-block-schedule-button`)
        if (target) {
          target.click()
        }
      })
    })
  }
}

if (!customElements.get('store-locator-map')) {
  customElements.define('store-locator-map', StoreLocatorMap)
}
